import type { RichTextConfig } from './richTextExtensions';

const asGlobal = (pattern: RegExp) => (pattern.global ? pattern : new RegExp(pattern.source, `${pattern.flags}g`));

function textNodesOf(body: HTMLElement): Text[] {
    const walker = body.ownerDocument.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    const nodes: Text[] = [];
    for (let node = walker.nextNode(); node; node = walker.nextNode()) nodes.push(node as Text);
    return nodes;
}

function wrapPlaceholders(textNode: Text, pattern: RegExp): void {
    const text = textNode.data;
    const matches = [...text.matchAll(pattern)];
    if (matches.length === 0) return;
    const doc = textNode.ownerDocument;
    const fragment = doc.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
        const start = match.index ?? 0;
        fragment.append(text.slice(cursor, start));
        const pill = doc.createElement('span');
        pill.setAttribute('data-placeholder', match[0]);
        fragment.append(pill);
        cursor = start + match[0].length;
    }
    fragment.append(text.slice(cursor));
    textNode.replaceWith(fragment);
}

export function toEditorHtml(html: string, config: RichTextConfig): string {
    if (!config.placeholderPattern || !html) return html;
    const pattern = asGlobal(config.placeholderPattern);
    if (!new RegExp(pattern.source, pattern.flags.replace('g', '')).test(html)) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    textNodesOf(doc.body).forEach((node) => wrapPlaceholders(node, pattern));
    return doc.body.innerHTML;
}

export function fromEditorHtml(html: string, config: RichTextConfig): string {
    if (!config.placeholderPattern || !html.includes('data-placeholder')) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.body.querySelectorAll('span[data-placeholder]').forEach((pill) => {
        pill.replaceWith(pill.getAttribute('data-placeholder') ?? '');
    });
    doc.body.normalize();
    return doc.body.innerHTML;
}
